/////////////////////////////////////////////////////////20260429/////////////////////////////////////////////////////////

import React from 'react'
import { useState, useEffect } from 'react'
import {
    addCommasToNumber,
    allProjects,
    contracts,
    getContract,
    getDate,
    myinfos,
    offerUid,
    uidproject,
    upgradeCheck,
    uploaddocufile,
    offerMessage,
} from '../../service/project'
import Projectedit from './Projedtedit'
import Projectpgs from './Projectpgs'
import Swal from 'sweetalert2'
import { ModalUser } from '../../service/components/Modals'
import Projectuserbox from './Projectuserbox'
import Projectdevelop from './Projectdevelop'
import {
    STEP,
    nextStep,
    prevStep,
    getStepOrder,
    canAdminStepUp,
    getAdminStepUpBlockMessage,
    getAdminStepDownWarningMessage,
} from '../Project/projectStepManager'

function Projectpgbox({
    handleChange,
    edit,
    pg,
    allpg,
    uppg,
    path,
    updates,
    setEdit,
    userId,
    setPgs,
    setupPgs,
    setallPg,
    admin,
    setupPg,
    setSelectedFiles,
}) {
    const [isOpens, setIsOpens] = useState(false)
    const openModalHandlers = () => {
        setIsOpens(!isOpens)
    }

    const [isHeaderFixeds, setIsHeaderFixeds] = useState(false)
    const [userinfo, setuserinfo] = useState('')
    const [dedit, setDedit] = useState(false)
    const [contract, setContract] = useState({
        title: '',
        deliverylocation: '',
        allprice: '',
        deposit: '',
        detail: '',
        startdate: '',
        lastdate: '',
        beforeprice: '',
        beforepricecon: '',
        middleprice: '',
        middlepricecon: '',
        afterprice: '',
        afterpricecon: '',
        companydate: '',
        estimate: '',
        estimatename: '',
        newestimate: '',
        newestimatename: '',
        specification: '',
        specificationname: '',
        newspecification: '',
        newspecificationname: '',
        develop1: '',
        develop1name: '',
        newdevelop1: '',
        newdevelop1name: '',
        develop2: '',
        develop3name: '',
        newdevelop2: '',
        newdevelop2name: '',
        develop3: '',
        develop3name: '',
        newdevelop3: '',
        newdevelop3name: '',
    })
    const [offer, setOffer] = useState({
        adminprice: '',
        adminterm: '',
        admincontent: '',
    })
    const [offerlist, setOfferlist] = useState('')
    const [stampid, setStampid] = useState('')
    const [fresh, setFresh] = useState(false)
    const [rightViewNum, setRightViewNum] = useState(0)
    const [pendingNextLabel, setPendingNextLabel] = useState('')
    const [didInitView, setDidInitView] = useState(false)

    function saveContract(date, code) {
        return contracts(
            pg && pg.uid,
            contract.title,
            contract.deliverylocation,
            contract.allprice,
            contract.deposit,
            contract.detail,
            contract.startdate,
            contract.lastdate,
            contract.beforeprice,
            contract.beforepricecon,
            contract.middleprice,
            contract.middlepricecon,
            contract.afterprice,
            contract.afterpricecon,
            contract.bankname,
            contract.bankowner,
            contract.bankaccount,
            date,
            code,
            contract.newspecificationname,
            contract.specification,
            pg.userId,
        ).then(function (response) {
            if (!response || !response.data) {
                return Promise.resolve(response)
            }

            if (contract.newspecification) {
                return Promise.resolve(
                    uploaddocufile(
                        contract.newspecification,
                        pg.uid,
                        contract.newspecificationname,
                        'specification',
                        pg.userId,
                    ),
                ).then(function () {
                    return response
                })
            }

            if (contract.newdevelop1) {
                return Promise.resolve(
                    uploaddocufile(contract.newdevelop1, pg.uid, contract.newdevelop1name, 'develop1', pg.userId),
                ).then(function () {
                    return response
                })
            }

            if (contract.newdevelop2) {
                return Promise.resolve(
                    uploaddocufile(contract.newdevelop2, pg.uid, contract.newdevelop2name, 'develop2', pg.userId),
                ).then(function () {
                    return response
                })
            }

            if (contract.newdevelop3) {
                return Promise.resolve(
                    uploaddocufile(contract.newdevelop3, pg.uid, contract.newdevelop3name, 'develop3', pg.userId),
                ).then(function () {
                    return response
                })
            }

            return Promise.resolve(response)
        })
    }

    const onClick = () => {
        saveContract(0, 0)
    }

    function getEstimateOfferOrder() {
        if (Array.isArray(offerlist) && offerlist.length % 2 === 0) {
            return offerlist.length > 0 ? offerlist.length + 1 : 1
        }

        if (offerlist && (offerlist.length === 1 || offerlist.length === 3)) {
            return offerlist.length === 1 ? 1 : 3
        }

        return null
    }

    function submitEstimateAndMoveNext() {
        var offerOrder = getEstimateOfferOrder()

        if (!offer.adminprice) {
            Swal.fire('재견적비용을 입력해주세요', '확인 버튼을 눌러 주세요', 'warning')
            return
        }

        if (!offer.adminterm) {
            Swal.fire('재견적기간을 입력해주세요', '확인 버튼을 눌러 주세요', 'warning')
            return
        }

        if (!(contract && (contract.estimate || contract.newestimate))) {
            Swal.fire('견적파일을 첨부해주세요', '확인 버튼을 눌러 주세요', 'warning')
            return
        }

        if (!offerOrder) {
            Swal.fire('견적 저장에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
            return
        }

        offerMessage(
            pg.uid,
            offer.adminprice,
            offer.adminterm,
            offer.admincontent,
            'admin',
            offerOrder,
            pg.userId,
            'estimate',
        ).then(function (offerRes) {
            if (!offerRes || !offerRes.data) {
                Swal.fire('견적 저장에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                return
            }

            var uploadPromise = contract.newestimate
                ? Promise.resolve(
                      uploaddocufile(contract.newestimate, pg.uid, contract.newestimatename, 'estimate', pg.userId),
                  )
                : Promise.resolve(true)

            uploadPromise.then(function () {
                saveContract(getDate(), contract.c2f ? 2 : 1).then(function (response) {
                    if (!response || !response.data) {
                        Swal.fire('제출에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                        return
                    }

                    upgradeCheck(pg.uid, STEP.ESTIMATE_RECEIVE, getStepPath(STEP.ESTIMATE_RECEIVE)).then(function (
                        stepRes,
                    ) {
                        if (stepRes.data) {
                            setPgs(function (prevPg) {
                                return {
                                    ...prevPg,
                                    adminstatus: STEP.ESTIMATE_RECEIVE,
                                }
                            })

                            setContract(function (prevContract) {
                                return {
                                    ...prevContract,
                                    estimate:
                                        prevContract && prevContract.estimate
                                            ? prevContract.estimate
                                            : contract.newestimate,
                                    estimatename:
                                        prevContract && prevContract.estimatename
                                            ? prevContract.estimatename
                                            : contract.newestimatename,
                                    newestimate: '',
                                    newestimatename: '',
                                }
                            })

                            setRightViewNum(1)
                            setDedit(false)

                            Swal.fire('견적서 제출 완료', '확인 버튼을 눌러 주세요', 'success').then(() => {
                                window.location.reload()
                            })
                        }
                    })
                })
            })
        })
    }

    const onClickss = () => {
        var current = getCurrentStep()

        const submitLabel =
            current === STEP.ESTIMATE_WRITE
                ? '견적서를 제출하시겠습니까?'
                : current === STEP.CONTRACT_WRITE
                ? '계약서를 제출하시겠습니까?'
                : current === STEP.DEV1
                ? '1단계 개발 보고서를 제출하시겠습니까?'
                : current === STEP.DEV2
                ? '2단계 개발 보고서를 제출하시겠습니까?'
                : current === STEP.FINAL_REPORT
                ? '3단계 개발 보고서를 제출하시겠습니까?'
                : '제출하시겠습니까?'

        Swal.fire({
            title: submitLabel,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니오',
            confirmButtonText: '예',
        }).then(function (confirmResult) {
            if (!confirmResult.isConfirmed) {
                return
            }

            if (current === STEP.ESTIMATE_WRITE) {
                submitEstimateAndMoveNext()
                return
            }

            if (current === STEP.DEV1 && !(contract && (contract.newdevelop1 || contract.develop1))) {
                Swal.fire('1단계 개발 보고서 파일을 첨부해주세요', '확인 버튼을 눌러 주세요', 'warning')
                return
            }

            if (current === STEP.DEV2 && !(contract && (contract.newdevelop2 || contract.develop2))) {
                Swal.fire('2단계 개발 보고서 파일을 첨부해주세요', '확인 버튼을 눌러 주세요', 'warning')
                return
            }

            if (current === STEP.FINAL_REPORT && !(contract && (contract.newdevelop3 || contract.develop3))) {
                Swal.fire('3단계 개발 보고서 파일을 첨부해주세요', '확인 버튼을 눌러 주세요', 'warning')
                return
            }

            saveContract(getDate(), contract.c2f ? 2 : 1).then(function (response) {
                if (!response || !response.data) {
                    Swal.fire('제출에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                    return
                }

                if (current === STEP.CONTRACT_WRITE) {
                    upgradeCheck(pg.uid, STEP.CONTRACT_RECEIVE, getStepPath(STEP.CONTRACT_RECEIVE)).then(function (
                        stepRes,
                    ) {
                        if (stepRes.data) {
                            setPgs(function (prevPg) {
                                return {
                                    ...prevPg,
                                    adminstatus: STEP.CONTRACT_RECEIVE,
                                }
                            })

                            setContract(function (prevContract) {
                                return {
                                    ...prevContract,
                                    d1: prevContract && prevContract.d1 ? prevContract.d1 : getDate(),
                                }
                            })

                            setPendingNextLabel('')
                            setDedit(false)

                            Swal.fire('계약서 제출 완료', '확인 버튼을 눌러 주세요', 'success').then(function () {
                                window.location.reload()
                            })
                        } else {
                            Swal.fire('단계 변경에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                        }
                    })
                    return
                }

                if (current === STEP.DEV1) {
                    upgradeCheck(pg.uid, STEP.DEV1_RECEIVE, getStepPath(STEP.DEV1_RECEIVE)).then(function (stepRes) {
                        if (stepRes.data) {
                            setPgs(function (prevPg) {
                                return {
                                    ...prevPg,
                                    adminstatus: STEP.DEV1_RECEIVE,
                                }
                            })

                            setContract(function (prevContract) {
                                return {
                                    ...prevContract,
                                    develop1:
                                        prevContract && prevContract.develop1
                                            ? prevContract.develop1
                                            : contract.newdevelop1,
                                    develop1name:
                                        prevContract && prevContract.develop1name
                                            ? prevContract.develop1name
                                            : contract.newdevelop1name,
                                    newdevelop1: '',
                                    newdevelop1name: '',
                                }
                            })

                            setRightViewNum(5)
                            setPendingNextLabel('')
                            setDedit(false)

                            Swal.fire('1단계 개발 보고서 제출 완료.', '', 'success').then(function () {
                                window.location.reload()
                            })
                        } else {
                            Swal.fire('단계 변경에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                        }
                    })
                    return
                }

                if (current === STEP.DEV2) {
                    upgradeCheck(pg.uid, STEP.DEV2_RECEIVE, getStepPath(STEP.DEV2_RECEIVE)).then(function (stepRes) {
                        if (stepRes.data) {
                            setPgs(function (prevPg) {
                                return {
                                    ...prevPg,
                                    adminstatus: STEP.DEV2_RECEIVE,
                                }
                            })

                            setContract(function (prevContract) {
                                return {
                                    ...prevContract,
                                    develop2:
                                        prevContract && prevContract.develop2
                                            ? prevContract.develop2
                                            : contract.newdevelop2,
                                    develop2name:
                                        prevContract && prevContract.develop2name
                                            ? prevContract.develop2name
                                            : contract.newdevelop2name,
                                    newdevelop2: '',
                                    newdevelop2name: '',
                                }
                            })

                            setRightViewNum(6)
                            setPendingNextLabel('')
                            setDedit(false)

                            Swal.fire('2단계 개발 보고서 제출 완료.', '', 'success').then(function () {
                                window.location.reload()
                            })
                        } else {
                            Swal.fire('단계 변경에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                        }
                    })
                    return
                }

                if (current === STEP.FINAL_REPORT) {
                    upgradeCheck(pg.uid, STEP.FINAL_REPORT_RECEIVE, getStepPath(STEP.FINAL_REPORT_RECEIVE)).then(
                        function (stepRes) {
                            if (stepRes.data) {
                                setPgs(function (prevPg) {
                                    return {
                                        ...prevPg,
                                        adminstatus: STEP.FINAL_REPORT_RECEIVE,
                                    }
                                })

                                setContract(function (prevContract) {
                                    return {
                                        ...prevContract,
                                        develop3:
                                            prevContract && prevContract.develop3
                                                ? prevContract.develop3
                                                : contract.newdevelop3,
                                        develop3name:
                                            prevContract && prevContract.develop3name
                                                ? prevContract.develop3name
                                                : contract.newdevelop3name,
                                        newdevelop3: '',
                                        newdevelop3name: '',
                                    }
                                })

                                setRightViewNum(7)
                                setPendingNextLabel('')
                                setDedit(false)

                                Swal.fire('3단계 개발 보고서 제출 완료.', '', 'success').then(function () {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire('단계 변경에 실패했습니다', '확인 버튼을 눌러 주세요', 'error')
                            }
                        },
                    )
                    return
                }

                setPendingNextLabel('')
                setDedit(false)
                Swal.fire('제출 완료', '확인 버튼을 눌러 주세요', 'success')
            })
        })
    }

    const handleChanges = (category, itemName) => {
        if (
            category === 'allprice' ||
            category === 'beforeprice' ||
            category === 'middleprice' ||
            category === 'afterprice'
        ) {
            setContract(function (prevState) {
                return {
                    ...prevState,
                    [category]: itemName.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                }
            })
        } else if (category === 'price') {
            const numericValue = parseFloat(itemName.replace(/,/g, ''))

            if (!isNaN(numericValue)) {
                setContract(function (prevState) {
                    return {
                        ...prevState,
                        [category]: addCommasToNumber(numericValue),
                    }
                })
            } else {
                setContract(function (prevState) {
                    return {
                        ...prevState,
                        [category]: '',
                    }
                })
            }
        } else if (category === 'adminprice' || category === 'adminterm' || category === 'admincontent') {
            const numericValue = parseFloat(itemName.replace(/,/g, ''))

            if (category === 'adminprice') {
                if (!isNaN(numericValue)) {
                    setOffer(function (prevState) {
                        return {
                            ...prevState,
                            [category]: addCommasToNumber(numericValue),
                        }
                    })
                } else {
                    setOffer(function (prevState) {
                        return {
                            ...prevState,
                            [category]: '',
                        }
                    })
                }
            } else {
                setOffer(function (prevState) {
                    return {
                        ...prevState,
                        [category]: itemName,
                    }
                })
            }
        } else {
            setContract(function (prevState) {
                return {
                    ...prevState,
                    [category]: itemName,
                }
            })
        }
    }

    function getCurrentStep() {
        if (pg && pg.adminstatus) return pg.adminstatus
        return STEP.TEMP
    }

    function getMaxRightViewNumByStep(step) {
        if (step === STEP.TEMP) return 0
        if (step === STEP.REGISTER) return 0

        if (step === STEP.ESTIMATE_WRITE) return 1
        if (step === STEP.ESTIMATE_RECEIVE) return 1
        if (step === STEP.ESTIMATE_APPROVE) return 1

        if (step === STEP.CONTRACT_WRITE) return 3
        if (step === STEP.CONTRACT_RECEIVE) return 3
        if (step === STEP.CONTRACT_SIGN) return 3

        if (step === STEP.DEPOSIT) return 4

        if (step === STEP.DEV1) return 5
        if (step === STEP.DEV1_RECEIVE) return 5
        if (step === STEP.DEV1_APPROVE) return 5

        if (step === STEP.MIDDLE) return 4

        if (step === STEP.DEV2) return 6
        if (step === STEP.DEV2_RECEIVE) return 6
        if (step === STEP.DEV2_APPROVE) return 6

        if (step === STEP.FINAL_REPORT) return 7
        if (step === STEP.FINAL_REPORT_RECEIVE) return 7
        if (step === STEP.FINAL_REPORT_APPROVE) return 7

        if (step === STEP.FINAL_PAY) return 4
        // if (step === STEP.DONE) return 7
        if (step === STEP.DONE) return 8

        return 0
    }

    function isWriteStep(step) {
        return (
            step === STEP.ESTIMATE_WRITE ||
            step === STEP.CONTRACT_WRITE ||
            step === STEP.DEV1 ||
            step === STEP.DEV2 ||
            step === STEP.FINAL_REPORT
        )
    }

    useEffect(
        function () {
            if (!pg || !pg.adminstatus || didInitView) return

            var maxView = getMaxRightViewNumByStep(pg.adminstatus)

            setRightViewNum(maxView)
            setDedit(isWriteStep(pg.adminstatus))
            setDidInitView(true)
        },
        [pg && pg.adminstatus, didInitView],
    )

    useEffect(
        function () {
            setDidInitView(false)
        },
        [path],
    )

    // useEffect(
    //     function () {
    //         if (pg && pg.adminstatus === STEP.ESTIMATE_WRITE) {
    //             setDedit(true)
    //         }
    //     },
    //     [pg],
    // )

    useEffect(
        function () {
            setPendingNextLabel('')
        },
        [pg && pg.adminstatus],
    )

    function getStepPath(step) {
        switch (step) {
            case STEP.TEMP:
                return 'temp'
            case STEP.REGISTER:
                return 'register'
            case STEP.ESTIMATE_WRITE:
                return 'estimateWrite'
            case STEP.ESTIMATE_RECEIVE:
                return 'estimateReceive'
            case STEP.ESTIMATE_APPROVE:
                return 'estimateApprove'
            case STEP.CONTRACT_WRITE:
                return 'contractWrite'
            case STEP.CONTRACT_RECEIVE:
                return 'contractReceive'
            case STEP.CONTRACT_SIGN:
                return 'contractSign'
            case STEP.DEPOSIT:
                return 'deposit'
            case STEP.DEV1:
                return 'dev1'
            case STEP.DEV1_RECEIVE:
                return 'dev1Receive'
            case STEP.DEV1_APPROVE:
                return 'dev1Approve'
            case STEP.MIDDLE:
                return 'middle'
            case STEP.DEV2:
                return 'dev2'
            case STEP.DEV2_RECEIVE:
                return 'dev2Receive'
            case STEP.DEV2_APPROVE:
                return 'dev2Approve'
            case STEP.FINAL_REPORT:
                return 'finalReport'
            case STEP.FINAL_REPORT_RECEIVE:
                return 'finalReportReceive'
            case STEP.FINAL_REPORT_APPROVE:
                return 'finalReportApprove'
            case STEP.FINAL_PAY:
                return 'finalPay'
            case STEP.DONE:
                return 'done'
            default:
                return ''
        }
    }

    function applyStepChange(next) {
        if (!pg || !next) return

        upgradeCheck(pg.uid, next, getStepPath(next)).then(function (response) {
            if (response.data) {
                setPgs(function (prevPg) {
                    return {
                        ...prevPg,
                        adminstatus: next,
                    }
                })

                if (next === STEP.DEPOSIT) {
                    setRightViewNum(4)
                    setDedit(false)
                } else if (next === STEP.DEV1) {
                    setRightViewNum(5)
                    setDedit(true)
                } else if (next === STEP.MIDDLE) {
                    setRightViewNum(4)
                    setDedit(false)
                } else if (next === STEP.DEV2) {
                    setRightViewNum(6)
                    setDedit(true)
                } else if (next === STEP.FINAL_REPORT) {
                    setRightViewNum(7)
                    setDedit(true)
                } else if (next === STEP.FINAL_PAY) {
                    setRightViewNum(4)
                    setDedit(false)
                } else if (next === STEP.DONE) {
                    // setRightViewNum(7)
                    setRightViewNum(8)

                    setDedit(false)
                } else {
                    setRightViewNum(getMaxRightViewNumByStep(next))
                    setDedit(false)
                }

                if (next === STEP.DONE) {
                    Swal.fire('프로젝트가 완료되었습니다!', '', 'success').then(function () {
                        window.location.reload()
                    })
                    return
                }

                Swal.fire('진행단계가 변경 되었습니다', '확인 버튼을 눌러 주세요', 'success')
            }
        })
    }

    // useEffect(
    //     function () {
    //         if (!pg || !pg.adminstatus) return

    //         if (
    //             (pg.adminstatus === STEP.ESTIMATE_WRITE && rightViewNum === 1) ||
    //             (pg.adminstatus === STEP.CONTRACT_WRITE && rightViewNum === 3) ||
    //             (pg.adminstatus === STEP.DEV1 && rightViewNum === 5) ||
    //             (pg.adminstatus === STEP.DEV2 && rightViewNum === 6) ||
    //             (pg.adminstatus === STEP.FINAL_REPORT && rightViewNum === 7)
    //         ) {
    //             setDedit(true)
    //         } else {
    //             setDedit(false)
    //         }
    //     },
    //     [pg && pg.adminstatus, rightViewNum],
    // )

    useEffect(function () {
        const handleScrollAndResize = () => {
            const newIsHeaderFixed = window.scrollY >= 330
            setIsHeaderFixeds(newIsHeaderFixed)

            const parentElement = document.querySelector('.addproject')
            const fixedElement = document.querySelector('.add_left.fixed')
            const fixedElements = document.querySelector('.add_left')

            if (parentElement && fixedElement) {
                const parentRect = parentElement.getBoundingClientRect()
                fixedElement.style.left = parentRect.left + 'px'
            } else if (fixedElements) {
                fixedElements.style.left = '0px'
            } else {
                console.error('Cannot find fixedElements element.')
            }
        }

        if (!admin) {
            allProjects()
                .then(function (response) {
                    setallPg(response.data)
                })
                .catch(function (error) {
                    console.error('Error fetching data:', error)
                })
        }

        if (admin) {
            uidproject(path)
                .then(function (response) {
                    const saveListWithConvertedMinicate = response.data.map(function (item) {
                        if (item.minicate) {
                            item.minicate = JSON.parse(item.minicate)
                            item.conditions = JSON.parse(item.conditions)
                        }
                        return item
                    })

                    // setPgs(saveListWithConvertedMinicate[0])
                    // setupPgs(saveListWithConvertedMinicate[0])

                    // myinfos(saveListWithConvertedMinicate[0].userId).then(function (response) {
                    //     if (response.data) {
                    //         setuserinfo(response.data[0])
                    //     }
                    // })

                    var selectedProject = saveListWithConvertedMinicate[0]

                    setPgs(selectedProject)
                    setupPgs(selectedProject)

                    if (selectedProject && selectedProject.userId) {
                        myinfos(selectedProject.userId).then(function (response) {
                            if (response.data && response.data[0]) {
                                setuserinfo(response.data[0])
                            } else {
                                setuserinfo(selectedProject)
                            }
                        })
                    } else {
                        setuserinfo(selectedProject || '')
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching data:', error)
                })

            getContract(path).then(function (response) {
                if (response.data) {
                    setContract(response.data[0])
                }
            })

            offerUid(path).then(function (response) {
                if (response.data) {
                    setOfferlist(response.data)
                }
            })
        }

        window.addEventListener('scroll', handleScrollAndResize)
        window.addEventListener('resize', handleScrollAndResize)

        return () => {
            window.removeEventListener('scroll', handleScrollAndResize)
            window.removeEventListener('resize', handleScrollAndResize)
        }
    }, [])

    const goEstimateWriteAndOpenEditor = () => {
        var current = getCurrentStep()
        var next = nextStep(current)

        if (next !== STEP.ESTIMATE_WRITE) {
            Swal.fire('견적서 작성 단계로 이동할 수 없습니다.', '확인 버튼을 눌러 주세요', 'error')
            return
        }

        Swal.fire({
            title: '견적서 작성 단계로 이동하시겠습니까?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니요',
            confirmButtonText: '네',
        }).then(function (result) {
            if (result.isConfirmed) {
                upgradeCheck(pg.uid, next, getStepPath(next)).then(function (response) {
                    if (response.data) {
                        setPgs(function (prevPg) {
                            return {
                                ...prevPg,
                                adminstatus: next,
                            }
                        })
                        setDedit(true)
                    }
                })
            }
        })
    }

    const upgrade = () => {
        var current = getCurrentStep()
        var next = nextStep(current)

        if (current === STEP.ESTIMATE_RECEIVE) {
            next = STEP.CONTRACT_WRITE
        }

        if (current === STEP.CONTRACT_RECEIVE) {
            next = STEP.DEPOSIT
        }

        if (!next || next === current) {
            Swal.fire('단계변동이 불가능합니다', '확인 버튼을 눌러 주세요', 'error')
            return
        }

        if (current === STEP.ESTIMATE_RECEIVE && !(contract && contract.b3f)) {
            Swal.fire(
                '수요기업의 견적서 승인 전에는 계약서 작성으로 이동할 수 없습니다.',
                '확인 버튼을 눌러 주세요',
                'warning',
            )
            return
        }

        if (current !== STEP.ESTIMATE_RECEIVE && !canAdminStepUp(current, contract)) {
            Swal.fire(getAdminStepUpBlockMessage(current, contract), '확인 버튼을 눌러 주세요', 'warning')
            return
        }

        Swal.fire({
            title: next + ' 단계로 변경하시겠습니까?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니오',
            confirmButtonText: '예',
        }).then(function (result) {
            if (result.isConfirmed) {
                applyStepChange(next)
            }
        })
    }

    const downgrade = () => {
        var current = getCurrentStep()
        var prev = prevStep(current)

        if (!prev || prev === current) {
            Swal.fire('단계변동이 불가능합니다', '확인 버튼을 눌러 주세요', 'error')
            return
        }

        Swal.fire({
            title: getAdminStepDownWarningMessage(current),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니요',
            confirmButtonText: '네',
        }).then(function (result) {
            if (result.isConfirmed) {
                applyStepChange(prev)
            }
        })
    }

    return (
        <div className={isHeaderFixeds ? 'w1480 h100 flex addproject r' : 'w1480 h100 flex addproject j'}>
            {pg && allpg ? (
                <div className={isHeaderFixeds ? 'add_left wide fixed' : 'add_left wide'}>
                    <Projectuserbox
                        upgrade={upgrade}
                        downgrade={downgrade}
                        edit={edit}
                        rightViewNum={rightViewNum}
                        setRightViewNum={setRightViewNum}
                        pg={pg}
                        allpg={allpg}
                        updates={updates}
                        setEdit={setEdit}
                        userId={userId}
                        admin={admin}
                        openModalHandlers={openModalHandlers}
                        dedit={dedit}
                        setDedit={setDedit}
                        onEstimateSubmitFromControlBox={onClickss}
                        contract={contract}
                        pendingNextLabel={pendingNextLabel}
                    />
                </div>
            ) : (
                ''
            )}

            {pg && allpg && !edit && !dedit ? (
                <Projectpgs
                    offerlist={offerlist}
                    setContract={setContract}
                    userinfo={userinfo}
                    contract={contract || {}}
                    admin={admin}
                    path={path}
                    setPgs={setPgs}
                    edit={edit}
                    setEdit={setEdit}
                    updates={updates}
                    setupPgs={setupPgs}
                    right={true}
                    pg={pg}
                    stampid={stampid}
                    setStampid={setStampid}
                    fresh={fresh}
                    upgrade={upgrade}
                    goEstimateWriteAndOpenEditor={goEstimateWriteAndOpenEditor}
                    rightViewNum={rightViewNum}
                    setRightViewNum={setRightViewNum}
                    exdata={{}}
                />
            ) : edit ? (
                <Projectedit
                    setSelectedFiles={setSelectedFiles}
                    setupPg={setupPg}
                    admin={admin}
                    handleChange={handleChange}
                    isHeaderFixeds={isHeaderFixeds}
                    updates={updates}
                    userId={userId}
                    pg={uppg}
                    edit={edit}
                />
            ) : dedit ? (
                <Projectdevelop
                    onClick={onClick}
                    onClickss={onClickss}
                    setDedit={setDedit}
                    offer={offer}
                    handleChanges={handleChanges}
                    offerlist={offerlist}
                    contract={contract}
                    project={pg}
                    userId={pg.userId}
                    sadmin={admin}
                />
            ) : (
                ''
            )}

            {isOpens ? (
                <ModalUser data={userinfo} openModalHandlers={openModalHandlers} isOpens={isOpens} admin={true} />
            ) : (
                ''
            )}
        </div>
    )
}

export default Projectpgbox
